export const createFormData = (org) => {
    const formData = new FormData();

    const {title, status, hasMinting, hasProducts, hasSales, hasWhitelabel, hasMysterybox, hasCheckout, hasCart, eupago_external_key, merchant_of_record, mbway_enabled} = org;

    const fields = [
      {key: "title", value: title},
      {key: "status", value: status},
    ]

    // a missing flag would be sent as "undefined", which Rails casts to true
    if (typeof merchant_of_record === "boolean") fields.push({key: "merchant_of_record", value: merchant_of_record});
    if (typeof mbway_enabled === "boolean") fields.push({key: "mbway_enabled", value: mbway_enabled});
    if (eupago_external_key) fields.push({key: "eupago_external_key", value: eupago_external_key});
    if (hasMinting) fields.push({key: "modules[]", value: "minting"});
    if (hasProducts) fields.push({key: "modules[]", value: "products"});
    if (hasSales) fields.push({key: "modules[]", value: "sales"});
    if (hasWhitelabel) fields.push({key: "modules[]", value: "whitelabel"});
    if (hasMysterybox) fields.push({key: "modules[]", value: "mysterybox"});
    if (hasCheckout) fields.push({key: "modules[]", value: "checkout"});
    if (hasCart) fields.push({key: "modules[]", value: "cart"});

    fields.forEach(field => {
      formData.append(field.key, field.value);
    });
    return formData;
  }